<script setup lang="ts">
//import { useLangsStore } from "~~/base/app/stores/langs"

const route = useRoute()

const LangsStore = useLangsStore()

const items = computed(() => [
	{
		label: LangsStore.getLangEntry("main_langs", "dexterial-navigation-services"),
		to: "#",
		class: "",
		active: route.hash == "",
		icon: "i-lucide-hand-platter",
	},
	{
		label: LangsStore.getLangEntry("main_langs", "dexterial-navigation-benefits"),
		to: "#benefits",
		class: "",
		active: route.hash == "#benefits", //text-white/80 hover:text-white text-lg text-white/80 hover:text-white text-lg
		icon: "i-lucide-hand-coins",
	},
	{
		label: LangsStore.getLangEntry("main_langs", "dexterial-navigation-technologies"),
		to: "#technologies",
		class: "",
		active: route.hash == "#technologies",
		icon: "i-lucide-hammer",
	},
	{
		label: LangsStore.getLangEntry("main_langs", "dexterial-navigation-industries"),
		to: "#industries",
		class: "",
		active: route.hash == "#industries",
		icon: "i-lucide-tool-case",
	},
	// {
	// 	label: LangsStore.getLangEntry("main_langs","dexterial-navigation-testimonials"),
	// 	to: "#testimonials",
	// 	class: "",
	// 	active: route.hash == "#testimonials",
	// 	icon: "i-lucide-tool-case",
	// },

	{
		label: LangsStore.getLangEntry("main_langs", "dexterial-navigation-faq"),
		to: "#faq",
		class: "",
		active: route.hash == "#faq",
		icon: "i-lucide-circle-help",
	},
])
</script>

<template>
	<UHeader
		class="bg-[#020227]/50"
		:toggle="false"
	>
		<template #left>
			<NuxtLink to="/">
				<LogoPro class="h-4 w-auto shrink-0 sm:h-6" />
			</NuxtLink>

			<UNavigationMenu
				:items="items"
				variant="link"
				class="ps-0 pt-1"
				:ui="{
					linkLabel: 'hover:text-white hidden sm:inline-flex p-0',
					link: 'hover:text-white px-1',
				}"
			/>
			<ContentContactBtn
				:inbody="false"
				class="pb-2"
			/>
			<!-- <UButtonGroup
				orientation="horizontal"
				variant=""
				class="mx-2"
			>
				<UButton
					color="primary"
					variant="outline"
					label="ro"
					@click="((LangsStore.context.lang_id = 'ro'), setPar(LangsStore.context, 'lang_id'))"
				/>
				<UButton
					color="primary"
					variant="outline"
					label="en"
					@click="((LangsStore.context.lang_id = 'en'), setPar(LangsStore.context, 'lang_id'))"
				/>
			</UButtonGroup> -->
		</template>

		<template #right>
			<UtilsLangSelector />
		</template>

		<template #body>
			<!-- <UNavigationMenu
				:items="items"
				orientation="vertical"
				class="-mx-2.5"
			/>

			<USeparator class="my-6" />

			<UButton
				label="Sign in"
				color="neutral"
				variant="subtle"
				to="/login"
				block
				class="mb-3"
			/>
			<UButton
				label="Sign up"
				color="neutral"
				to="/signup"
				block
			/> -->
		</template>
	</UHeader>
</template>
